export default __webpack_public_path__ + "static/media/PharmacyPrescription.5ef47de5.svg";